export var Catalog;
(function (Catalog) {
    let Type;
    (function (Type) {
        let EBundlePriceType;
        (function (EBundlePriceType) {
            EBundlePriceType[EBundlePriceType["dynamic"] = 0] = "dynamic";
            EBundlePriceType[EBundlePriceType["static"] = 1] = "static";
        })(EBundlePriceType = Type.EBundlePriceType || (Type.EBundlePriceType = {}));
    })(Type = Catalog.Type || (Catalog.Type = {}));
    let Model;
    (function (Model) {
        /**
         * Category
         */
        let Category;
        (function (Category) {
            let Data;
            (function (Data) {
                Data.v1part = ['id', 'name', 'parent', 'type', 'store'];
                Data.v2part = ['image', 'products', 'url', 'short_description'];
            })(Data = Category.Data || (Category.Data = {}));
        })(Category = Model.Category || (Model.Category = {}));
        let Product;
        (function (Product) {
            let Data;
            (function (Data) {
                Data.v1part = [
                    'id',
                    'url',
                    'name',
                    'sku',
                    'status',
                    'visibility',
                    'catalog',
                    'search',
                    'image',
                    'org_price',
                    'price',
                    'bundle_sp_perc',
                    'tax',
                    'is_from_price',
                    'group_price',
                    'group_org_price',
                    'store',
                    'type_id',
                    'type'
                ];
                Data.v2part = [
                    'parent',
                    'type_id',
                    'reviews',
                    'short_description',
                    'news_from_date',
                    'news_to_date',
                    'isDivergent',
                    'categories',
                    'first',
                    'last',
                    'options',
                    'price_type',
                    'directChildrenIds',
                    'indirectChildren',
                    'stockMap',
                    'listing_label',
                    'variants'
                ];
            })(Data = Product.Data || (Product.Data = {}));
        })(Product = Model.Product || (Model.Product = {}));
    })(Model = Catalog.Model || (Catalog.Model = {}));
})(Catalog || (Catalog = {}));
